import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import i18next from "i18next";
import EditRVDRequest from "./EditRVDRequest";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SubgridPanel from "@mnjsplatform/components/lib/common/Subgrid/SubgridPanel";
import ReportPlaceholder from "../Common/ReportPlaceholder";
import CopyRequestForm from "./CopyRequestForm";
import doc_Employee from "../../assets/doc/Instruction by request on work in holiday employee.docx";
import doc_Manager from "../../assets/doc/Instruction by request on work in holiday manager.docx";
import {Link} from "react-router-dom";
import DelegateRvdInfo from "./DelegateRvdInfo";
import queryString from "query-string";
import {withRouter} from "react-router";

class RvdRequestList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showEditForm: false, rowKey: null, showErrors: false, showCopyRequestForm: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.WorkHolReq_POx_ListReqUnComp.execute());
            await this.props.dispatch(this.props.WorkHolReq_POx_ListReqComp.execute({}, {withParams: true}));
            const documentKey = queryString.parse(this.props.location.search);
            const reqIntId = documentKey["id"];
            if (reqIntId) {
                this.showRequest({ReqIntId: reqIntId});
            }
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    onRefresh = async () => {
        try {
            await this.props.dispatch(this.props.WorkHolReq_POx_ListReqUnComp.refresh());
            await this.props.dispatch(this.props.WorkHolReq_POx_ListReqComp.refresh());
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    sendRequest = async (rowKey, status, fromModal = false) => {
        if (status === 'Facting') {
            if (fromModal) await confirm(i18next.t("RVD_ApproveRequest_Confirm"));
        } else await confirm(i18next.t("RVD_ApproveOrder"));
        const key = Object.assign({}, rowKey, {IsLiftStatus: 1});
        if (status !== 'Facting' || fromModal) {
            await this.props.dispatch(this.props.WorkHolReq_POx_ChangeStatus.execute(key));
            if (!this.props.WorkHolReq_POx_ChangeStatus.isError) await this.onRefresh();
        } else this.showRequest(rowKey);
    }

    deleteRequest = async (rowKey, dataItem) => {
        try {
            await confirm(i18next.t("RVD_DeleteRequest"));
            await this.props.dispatch(this.props.WorkHolReq_POx_ListReq_Del.execute(rowKey));
            if (!this.props.WorkHolReq_POx_ListReq_Del.isError)
                await this.props.dispatch(dataItem.refresh());
            //await this.onRefresh();
        }
        catch (e) {
        }
    }

    revokeRequest = async (rowKey) => {
        await confirm(i18next.t("RVD_ConfirmRevokeApprovement"));
        const key = Object.assign({}, rowKey, {IsLiftStatus: 0});
        await this.props.dispatch(this.props.WorkHolReq_POx_ChangeStatus.execute(key));
        if (!this.props.WorkHolReq_POx_ChangeStatus.isError)
            await this.onRefresh();
    }

    getListReq = (methodName) => {
        switch (methodName) {
            case this.props.WorkHolReq_POx_ListReqUnComp.methodName:
                return this.props.WorkHolReq_POx_ListReqUnComp;
            case this.props.WorkHolReq_POx_ListReqComp.methodName:
                return this.props.WorkHolReq_POx_ListReqComp;
        }
    }

    copyRequest = async (rowKey) => {
        try {
            await confirm(i18next.t("RVD_ConfirmCopyRequest"));
            this.showCopyRequestForm(rowKey);
        }
        catch (e) {
        }
    }

    /*
        copyRequest = async (rowKey, dataItem) => {
            await confirm(i18next.t("Вы хотите продублировать заявку?"));
            await this.props.dispatch(this.props.WorkHolReq_POx_CopyReq.execute({FromReqIntId: rowKey.ReqIntId}, {withParams: true}));
            if (!this.props.WorkHolReq_POx_CopyReq.isError) {
                const toReqIntId = this.props.WorkHolReq_POx_CopyReq_Params.getField(0, 'ToReqIntId');
                console.log('toReqIntId: ' + toReqIntId);
                //await this.props.dispatch(dataItem.refresh());
                this.showRequest({ReqIntId: toReqIntId});
            }
        }
    */

    sendExcelToEmail = async (rowKey) => {
        try {
            await confirm(i18next.t("ScheduleChangeRequestList_RequestSending_ReceiveOrder_Checkbox"));
            await this.props.dispatch(this.props.WorkHolReq_POx_ReqCmdSendEMail.execute(rowKey));
        }
        catch (e) {
        }
    }

    showErrors = async (rowKey) => {
        await this.props.dispatch(this.props.WorkHolReqErr_POx_List.execute(rowKey, {newItem: true}));
        if (!this.props.WorkHolReqErr_POx_List.isError) this.setState({showErrors: true, rowKey: rowKey});
    }

    renderRequestList = (cellParams) => {
        const rowKey = cellParams.dataItem.getRowKey(cellParams.row);
        const status = cellParams.row.ReqStatusId;
        let upStatusCmdTitle, downStatusCmdTitle;
        if (status === 'Prepare') {
            upStatusCmdTitle = i18next.t("RVD_CreateOrder");
        } else if (status === 'Facting') {
            //upStatusCmdTitle = i18next.t("Ввод факта завершен");
            upStatusCmdTitle = i18next.t("RVD_ApproveRequest");
            downStatusCmdTitle = i18next.t("RVD_DisbandOrder");
        } else if (status === 'Approve') {
            downStatusCmdTitle = i18next.t("RVD_RevokeApprovement");
        }

        if (cellParams.fieldInfo.Name === "RowActions") {
            return (<div>
                {cellParams.row.__IsError === 1 &&
                    <button className="btn" type="button" style={{color: "#bd2130"}} title={i18next.t("RVD_ErrorList")}>
                        <i className="fa fa-info-circle ml-2 gridcell-tooltip"
                           onClick={() => this.showErrors(rowKey)}/>&nbsp;
                    </button>}
                {cellParams.row._IsCanLiftStatus === 1 && <button className="btn" type="button" style={{color: "brown"}}
                                                                  title={upStatusCmdTitle}>
                    <i className="fas fa-paper-plane fa-lg" onClick={() => this.sendRequest(rowKey, status)}/>&nbsp;
                </button>}
                {cellParams.row._IsCanDownStatus === 1 && <button className="btn" type="button" style={{color: "brown"}}
                                                                  title={downStatusCmdTitle}>
                    <i className="fas fa-undo fa-lg" onClick={() => this.revokeRequest(rowKey)}/>&nbsp;
                </button>}
                {cellParams.row._IsCanDelete === 1 && <button className="btn" type="button" style={{color: "red"}}
                                                              title={i18next.t("ScheduleChangeRequest_DeleteRequest")}>
                    <i className="fas fa-trash-alt fa-lg"
                       onClick={() => this.deleteRequest(rowKey, cellParams.dataItem)}/>&nbsp;
                </button>}
                {cellParams.row._IsCanPrintCmd === 1 &&
                    <ReportPlaceholder reportKey="CmdPayHoliday1" reportId="CmdPayHoliday1" title={i18next.t("Print")}>
                        {(reportParamsItem, build) => {
                            return (<>
                                    <button className="btn" title={i18next.t("Print")} style={{color: "brown"}}>
                                        <i className="fas fa-print fa-lg" onClick={async (e) => {
                                            e.preventDefault();
                                            await this.props.dispatch(reportParamsItem.setField(0, "ReqIntId", rowKey.ReqIntId));
                                            await build();
                                        }}/>&nbsp;
                                    </button>
                                </>);
                        }}
                    </ReportPlaceholder>}
                {cellParams.row._IsCanSendCmd === 1 && <button className="btn" type="button" style={{color: "brown"}}
                                                               title={i18next.t("ScheduleChangeRequest_SendExcelToEmail")}>
                    <i className="fas fa-file-excel fa-lg" onClick={() => this.sendExcelToEmail(rowKey)}/>&nbsp;
                </button>}
                {cellParams.row._IsCanCopyCmd === 1 && <button className="btn" type="button" style={{color: "brown"}}
                                                               title={i18next.t("RVD_CopyRequest2")}>
                    <i className="fas fa-copy fa-lg"
                       onClick={() => this.copyRequest(rowKey, cellParams.dataItem)}/>&nbsp;
                </button>}
            </div>);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }

    cellStyleProvider_RVDRequestList = (dataItem, rowIndex, fieldInfo) => {
        const isNeedApprove = dataItem.getField(rowIndex, '_IsApproveTime') === 1;
        if (fieldInfo?.Name === "RowActions") return null;
        const error = dataItem.getField(rowIndex, '__IsError') === 1;
        const style = Object.assign({}, {cursor: "pointer"}, {color: (isNeedApprove ? 'red' : null)});
        if (error) {
            return {
                ...style, color: "#bd2130"
            };
        }
        return style;
    }

    onApplyParams = (e) => {
        e.preventDefault();
        this.applyParams();
    }

    applyParams = async () => {
        await this.props.dispatch(this.props.WorkHolReq_POx_ListReqComp.applyParams(this.props.WorkHolReq_POx_ListReqComp_Params));
    }

    renderParams = (h) => {
        return (<>
                <div className="row">
                    <div className="col-md-12">
                        {h.fs.map(fld => {
                            return (<React.Fragment key={fld.fieldInfo.Name}>
                                <div className="row">
                                    <div className="col-md-3 text-md-right field-title">
                                        {h.lbl(fld.Name)}
                                    </div>
                                    <div className="col-md-9">
                                        {h.ed(fld.Name)}
                                    </div>
                                </div>
                                <hr/>
                            </React.Fragment>)
                        })}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 text-right">
                        <button title="Apply" onClick={this.onApplyParams}
                                className="btn btn-regular -goahead ml1ex">{i18next.t('Accept')}</button>
                    </div>
                </div>
            </>)
    }

    onCellClick = (row, fieldInfo, e) => {
        if (fieldInfo.Name !== "RowActions") {
            this.showRequest({ReqIntId: row.ReqIntId});
        }
    }

    showCopyRequestForm = (rowKey) => {
        this.setState({rowKey: rowKey, showCopyRequestForm: true});
    }

    hideCopyRequestForm = async (rowKey) => {
        this.setState({showCopyRequestForm: false});
        if (rowKey) await this.requestCreated(rowKey);
    }

    showRequest = (rowKey) => {
        this.setState({rowKey: rowKey, showEditForm: true});
    }

    hideRequest = async () => {
        this.setState({showEditForm: false});
        await this.onRefresh();
//        this.setState({showEditForm: false}, () => this.props.dispatch(this.props.WorkHolReq_POx_ListReqUnComp.refresh()));
//        this.setState({showEditForm: false}, this.onRefresh)
    }

    requestCreated = async (rowKey) => {
        await this.props.dispatch(this.props.WorkHolReq_POx_ListReq_One.refresh());
        this.showRequest(rowKey);
    }

    render() {
        const isNeedApprove = this.props.WorkHolReq_POx_ListReqUnComp.rowsCount() > 0 && this.props.WorkHolReq_POx_ListReqUnComp.getField(0, '_IsProxyRole ') === 1;
        return (<>
                {this.state.showErrors && <SubgridPanel dataItem={this.props.WorkHolReqErr_POx_List} onClose={() => {
                    this.setState({showErrors: false})
                }} readOnly={true} title={i18next.t("RVD_ErrorList")}/>}
                {/*
                <PlaceholderWrapper placeholderId="10" showHeaderTitle={true} canCollapse={true} showSplitterLine={true} title={i18next.t('RVD_InstructionTitle')}>
                    {this.getInstruction()}
                </PlaceholderWrapper>
*/}

                <PlaceholderWrapper placeholderId="20"
                                    title={<><i
                                        className='fa fa-file-text-o'/> {i18next.t("RVD_Request_List_1")}</>}
                                    showSplitterLine={false} canCollapse={true}>
                    <div className="text-left" style={{marginBottom: '10px'}}>
                        <button type="button"
                                className="btn btn-regular -goahead ml1ex"
                                onClick={() => this.showRequest(null)}
                                disabled={false}>{i18next.t("CreateRequest")}</button>
                        <span className="text-info">{isNeedApprove && i18next.t('RVD_IsProxyRole')}</span>
                    </div>
                    <GridView dataItem={this.props.WorkHolReq_POx_ListReqUnComp} allowPagination={true} readOnly={true}
                              onCellClick={this.onCellClick}
                              renderCellEx={this.renderRequestList}
                              cellStyleProvider={this.cellStyleProvider_RVDRequestList}
                    />
                </PlaceholderWrapper>
                {this.props.type === 'ManagerOffice' && <DelegateRvdInfo/>}
                <PlaceholderWrapper placeholderId="30" collapsed={true}
                                    title={<><i
                                        className='fa fa-check-circle-o'/> {i18next.t("RVD_Request_List_2")}</>}
                >
                    <PlaceholderWrapper placeholderId="25" showHeaderTitle={true} canCollapse={false}
                                        showSplitterLine={false} title={<><i className='fa fa-filter'/> {i18next.t("Filters")}</>}
                                        showInstruction={false}
                    >
                        <ComplexParam dataItem={this.props.WorkHolReq_POx_ListReqComp_Params}
                                      parentDataItem={this.props.WorkHolReq_POx_ListReqComp}
                                      showSearchBar={false} showApplyButton={false} autoApplyParams={false}
                                      renderParams={this.renderParams}/>
                    </PlaceholderWrapper>
                    <GridView dataItem={this.props.WorkHolReq_POx_ListReqComp} allowPagination={true}
                              readOnly={true}
                              onCellClick={this.onCellClick}
                              renderCellEx={this.renderRequestList}
                              cellStyleProvider={this.cellStyleProvider_RVDRequestList}
                    />
                </PlaceholderWrapper>
                {this.state.showEditForm && <EditRVDRequest dataItem={this.props.WorkHolReq_POx_ListReq_One}
                                                            rowKey={this.state.rowKey}
                                                            addMode={this.state.rowKey === null}
                                                            onCreated={this.requestCreated}
                                                            onSendRequest={this.sendRequest}
                                                            onClose={this.hideRequest}
                                                            onRefresh={this.onRefresh}/>}
                {this.state.showCopyRequestForm && <CopyRequestForm rowKey={this.state.rowKey}
                                                                    onClose={this.hideCopyRequestForm}/>}
            </>)
    }
}

RvdRequestList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    WorkHolReq_POx_ListReqUnComp: PropTypes.object,
    WorkHolReq_POx_ListReqComp: PropTypes.object,
    WorkHolReq_POx_ListReqComp_Params: PropTypes.object,
    WorkHolReq_POx_ListReq_One: PropTypes.object,
    WorkHolReq_POx_ListReq_Del: PropTypes.object,
    WorkHolReq_POx_ChangeStatus: PropTypes.object,
    WorkHolReq_POx_CopyReq: PropTypes.object,
    WorkHolReq_POx_CopyReq_Params: PropTypes.object,
    WorkHolReq_POx_ReqCmdSendEMail: PropTypes.object,
    WorkHolReqErr_POx_List: PropTypes.object
}

RvdRequestList.defaultProps = {};

function mapStateToProps(state, ownProps) {
    //console.log(`type: ${ownProps.type}`);
    return {
        WorkHolReq_POx_ListReqUnComp: (ownProps.type === 'PrivateOffice' ? state.rvdState.WorkHolReq_POx_ListReqUnComp : state.rvdState.WorkHolReq_POBx_ListReqUnComp),
        WorkHolReq_POx_ListReqComp: (ownProps.type === 'PrivateOffice' ? state.rvdState.WorkHolReq_POx_ListReqComp : state.rvdState.WorkHolReq_POBx_ListReqComp),
        WorkHolReq_POx_ListReqComp_Params: (ownProps.type === 'PrivateOffice' ? state.rvdState.WorkHolReq_POx_ListReqComp_Params : state.rvdState.WorkHolReq_POBx_ListReqComp_Params),
        WorkHolReq_POx_ListReq_One: (ownProps.type === 'PrivateOffice' ? state.rvdState.WorkHolReq_POx_ListReq_One : state.rvdState.WorkHolReq_POBx_ListReq_One),
        WorkHolReq_POx_ListReq_Del: state.rvdState.WorkHolReq_POx_ListReq_Del,
        WorkHolReq_POx_ChangeStatus: state.rvdState.WorkHolReq_POx_ChangeStatus,
        WorkHolReq_POx_CopyReq: state.rvdState.WorkHolReq_POx_CopyReq,
        WorkHolReq_POx_CopyReq_Params: state.rvdState.WorkHolReq_POx_CopyReq_Params,
        WorkHolReq_POx_ReqCmdSendEMail: (ownProps.type === 'PrivateOffice' ? state.rvdState.WorkHolReq_POx_ReqCmdSendEMail : state.rvdState.WorkHolReq_POBx_ReqCmdSendEMail),
        WorkHolReqErr_POx_List: state.rvdState.WorkHolReqErr_POx_List
    }
}

export default withRouter(connect(mapStateToProps)(RvdRequestList));